import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { lower } from "change-case";
import { Form, reduxForm, getFormValues, SubmissionError } from "redux-form";
import { Field } from "redux-form";
import { Button, Icon, Breadcrumb, Confirm } from "semantic-ui-react";
import FieldInput, { InputType as type } from "components/SemanticForm";
import { scrollToFirstValidateFailElement } from "core/utilities";
import { validations, validateCase as vCase } from "core/validate";
import { SearchUsernameContainer, DataListCont } from "./styled";
import {
  getHrmsMembers,
  getUserByRole,
  getListRoleK2,
  clearSearchRoleK2,
} from "ducks/member";
import { MainBodyContent, TablePagination } from "components";
import { supportForUserPath, roleMainSupportForUserPath } from "routes";
import ReactTable from "react-table";
import { columns } from "./AttributeData";

const SearchUserByRole = (props) => {
  const { listRoleK2, listRoleK2Loading, reset, history, userByRole } = props;
  const userPageSize = parseInt(localStorage.getItem("userPageSize") || "10");
  
  useEffect(() => {
    props.getListRoleK2();
    return () => {
      props.clearSearchRoleK2();
    };
  }, []);

  const listRoleK2Options = listRoleK2.map((m) => ({
    value: lower(m),
    text: `${m}`,
  }));

  function callApiSearch() {
    props.getUserByRole(props.valueForm.role, reset);
  }

  return (
    <MainBodyContent
      headerTitle="Search Username By Role K2"
      breadcrumbs={
        <Breadcrumb
          icon="right angle"
          sections={[
            {
              key: "Support",
              content: "Support",
              link: true,
              onClick: () => {
                history.push(supportForUserPath);
              },
            },
            {
              key: "role",
              content: "Role K2",
              link: true,
              onClick: () => {
                history.push(roleMainSupportForUserPath);
              },
            },
            {
              key: "searchuser",
              content: "Search Username By Role K2",
              active: true,
            },
          ]}
        />
      }
    >
      <SearchUsernameContainer>
        <Form>
          <div className="rowFields">
            <Field
              name="role"
              label="Role"
              loading={listRoleK2Loading}
              options={listRoleK2Options}
              type={type.select}
              component={FieldInput}
              require
              className={"halfRow"}
            />
            <div className="btnContainer" style={{ alignContent: "center" }}>
              <Button
                type="button"
                content="Search"
                color="blue"
                icon="paper plane outline"
                labelPosition="right"
                style={{ marginRight: "5px" }}
                onClick={() => callApiSearch()} //call api search
              />
            </div>
          </div>
        </Form>
        <DataListCont>
          <ReactTable
            data={Object.keys(userByRole).length > 0 ? userByRole.data : []}
            columns={columns}
            defaultPageSize={userPageSize}
            noDataText="No Data found"
            previousText={<Icon name="arrow alternate circle left" />}
            nextText={<Icon name="arrow alternate circle right" />}
            className="-striped -highlight"
          />
        </DataListCont>
      </SearchUsernameContainer>
    </MainBodyContent>
  );
};
const mapStateToProps = (state) => {
  return {
    user: state.authen.user,
    members: state.member.members,
    memberLoading: state.member.memberLoading,
    userByRole: state.member.userByRole,
    listRoleK2: state.member.listRoleK2,
    listRoleK2Loading: state.member.listRoleK2Loading,
    valueForm: getFormValues("SearchUserByRoleForm")(state) || {},
  };
};

const mapDispatchToProps = {
  getHrmsMembers,
  getUserByRole,
  getListRoleK2,
  clearSearchRoleK2
};

const validate = (values) => {
  let errors = {};
  validations(values, "docNumber", [vCase.require], errors);

  return errors;
};

const SearchUserByRoleForm = reduxForm({
  form: "SearchUserByRoleForm",
  enableReinitialize: true,
  onSubmitFail: scrollToFirstValidateFailElement,
  validate,
})(SearchUserByRole);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SearchUserByRoleForm);
